<template>
    <div class="carousel-3d-slide" :style="slideStyle" :class="computedClasses" @click="goTo()">
        <slot :index="index" :isCurrent="isCurrent" :leftIndex="leftIndex" :rightIndex="rightIndex"/>
    </div>
</template>

<script>
    export default {
        name: 'slide',
        props: {
            index: {
                type: Number
            }
        },
        data() {
            return {
                parent: this.$parent,
                styles: {},
                zIndex: 999,
                counter: 0
            }
        },
        computed: {
            isCurrent() {
                return this.index === this.parent.currentIndex
            },
            leftIndex() {
                if (this.parent.oneDirectional && this.getSideIndex(this.parent.leftIndices) > this.parent.currentIndex - 1) return -1;
                return this.getSideIndex(this.parent.leftIndices)
            },
            rightIndex() {
                if (this.parent.oneDirectional && this.getSideIndex(this.parent.rightIndices) > this.parent.total - this.parent.currentIndex - 2) return -1;
                return this.getSideIndex(this.parent.rightIndices)
            },
            slideStyle() {
                this.counter;
                let styles = {};
                if (!this.isCurrent) {
                    const lIndex = this.leftIndex;
                    const rIndex = this.rightIndex;
                    if (rIndex >= 0 || lIndex >= 0) {
                        styles = rIndex >= 0 ? this.calculatePosition(rIndex, true) : this.calculatePosition(lIndex, false);
                        styles.opacity = 1;
                        styles.visibility = 'visible'
                    }
                    if (this.parent.hasHiddenSlides) {
                        if (this.matchIndex(this.parent.leftOutIndex)) {
                            styles = this.calculatePosition(this.parent.leftIndices.length - 1, false)
                        } else if (this.matchIndex(this.parent.rightOutIndex)) {
                            styles = this.calculatePosition(this.parent.rightIndices.length - 1, true)
                        }
                    }
                } else {
                    //styles = {transform:'translateX('+this.parent.$el.clientWidth/2-this.$el.clientWidth/2+'px)'};
                    styles = this.calculatePosition(this.leftIndex, false);
                }
                return Object.assign(styles, {
                    'border-width': this.parent.border + 'px',
                    //    'width': this.parent.slideWidth + 'rem',
                    'transition': ' transform ' + this.parent.animationSpeed + 'ms, ' +
                        '               opacity ' + this.parent.animationSpeed + 'ms, ' +
                        '               visibility ' + this.parent.animationSpeed + 'ms'
                })
            },
            computedClasses() {
                return {
                    [`left-${this.leftIndex + 1}`]: this.leftIndex >= 0,
                    [`right-${this.rightIndex + 1}`]: this.rightIndex >= 0,
                    'current': this.isCurrent,
                    [`slide-${this.index}`]: true
                }
            }
        }, mounted() {
            let styleTag = document.createElement("style");
            document.head.appendChild(styleTag);
            let sheet = styleTag.sheet;
            let width = this.$el.clientWidth;
            sheet.addRule('.slide-' + this.index + '.current::after', 'border-width:' + width / 8 + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px');
            window.addEventListener('resize', this.resize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.resize)
        },
        methods: {
            resize() {
                this.counter++;
            },
            getSideIndex(array) {
                let index = -1;
                array.forEach((pos, i) => {
                    if (this.matchIndex(pos)) {
                        index = i
                    }
                });
                return index
            },
            matchIndex(index) {
                return (index >= 0) ? this.index === index : (this.parent.total + index) === this.index
            },
            calculatePosition(i, positive) {
                let currentIndex = this.parent.currentIndex;
                if (typeof this.parent.$children[currentIndex].$el !== 'undefined') {
                    let currentWidth = this.parent.$children[currentIndex].$el.clientWidth;
                    let widthToAdd = 0;
                    for (let j = 0; j < this.parent.$children.length; j++) {
                        if (positive && this.parent.$children[j].rightIndex < i && this.parent.$children[j].rightIndex > -1) {
                            widthToAdd += this.parent.$children[j].$el.clientWidth;
                        } else if (!positive && this.parent.$children[j].leftIndex <= i && this.parent.$children[j].leftIndex > -1) {
                            widthToAdd += this.parent.$children[j].$el.clientWidth;
                        }

                    }
                    let width = this.parent.$el.clientWidth / 2;
                    let leftremain2 = positive ? width + (currentWidth / 2) + widthToAdd : width - (currentWidth / 2) - widthToAdd;
                    const transform = (positive)
                        ? 'translateX(' + leftremain2 + 'px) '
                        : 'translateX(' + (leftremain2) + 'px)  ';
                    return {
                        transform: transform
                    }
                } else {
                    return {};
                }

            },
            goTo() {
                if (!this.isCurrent) {
                    if (this.parent.clickable === true) {
                        this.parent.goFar(this.index)
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .carousel-3d-slide {
        position: absolute;
        opacity: 0;
        visibility: hidden;
        overflow: hidden;
        top: 0;
        background-size: cover;
        margin: 0;
        box-sizing: border-box;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        margin-top: .5rem;
        padding-left: 3rem;
        padding-right: 3rem;
        cursor: pointer;
    }

    .carousel-3d-slide img {
        width: 100%;
    }

    .carousel-3d-slide.current {
        opacity: 1 !important;
        visibility: visible !important;
        z-index: 999;
        background-color: $pink;
        color: #fff;
        margin-top: 0 !important;
        height: 6rem !important;
        overflow: initial !important;
        text-align: center;
        display: block;
        cursor: default;
    }

    .carousel-3d-slide.current:after {
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        width: 0px;
        height: 0px;
        -webkit-transform: rotate(360deg);
        border-style: solid;
        border-color: $pink transparent transparent transparent;

    }
</style>